import { useEffect, useRef } from 'react';
import { Box, Text } from '@oneloop/jopijs';
import styles from './styles.module.scss';

const TAGS = [
  { id: 1, value: '[[contact_name]]' },
  { id: 2, value: '[[contact_first_name]]' },
  { id: 3, value: '[[starred_properties]]' },
  { id: 4, value: '[[starred_develompents]]' },
  { id: 5, value: '[[active_searches]]' },
  { id: 6, value: '[[agent_name]]' },
  { id: 7, value: '[[agent_first_name]]' },
];

function DynamicTagsPicker({ editor, handleDropdown }) {
  const tagsRef = useRef(null);

  const handleCloseDynamicTags = () => {
    handleDropdown({ open: false });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tagsRef.current && !tagsRef.current.contains(event.target)) {
        handleCloseDynamicTags();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickTag = (tag) => {
    const { value } = tag;
    const BLANK_SPACE = ' ';

    editor
      .chain()
      .focus()
      .insertContent(value)
      .insertContent(BLANK_SPACE)
      .run();

    handleCloseDynamicTags();
  };

  return (
    <Box ref={tagsRef} className={styles.container}>
      <Text className={styles.title}>Dynamic tags</Text>
      <Text className={styles.subtitle}>To use in the text message</Text>
      <Box className={styles['tags-wrapper']}>
        {TAGS.map((tag) => (
          <Box
            key={tag.id}
            as="button"
            className={styles.tag}
            onClick={() => handleClickTag(tag)}
          >
            {tag.value}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default DynamicTagsPicker;
